import '../App.css';
import '../Tileandpopout.css';

const SketchTile = ({img, dir, slct, updateSelect}) => {

  const postLoad = ( event ) => {
    event.target.classList.add('loaded')
  }

  return(
      <div onClick={ () => updateSelect(`userdata/sketches/${dir}/${img}`) } className='tile'>
        <img src={`userdata/sketches/${dir}/${img}`} className='sketchtile-img lazyloader' loading='lazy' onLoad={(e) => postLoad(e)} alt='tile' />
      </div>
  )

}

export default SketchTile;